import React, { useEffect, useState } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'
import dayjs from 'dayjs'
import { CaretDownIcon, Chip } from '@okcredit/web-lib'
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker'
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css'
import { THEME } from 'components/theme'
import { getToday } from 'shared/utils/time'
import {
  DATE_FILTER_TYPE,
  DATE_FILTER_TYPE_VS_LABEL,
  getDateFilterDetails,
  IDateFilter
} from './DateFilter.constants'
import DateFilterStyles from './DateFilter.styles'

const styles = createUseStyles(DateFilterStyles)

const DateFilter: React.FC<{
  onClick: (filter: IDateFilter) => void
  activeFilterLabel: string
}> = ({ onClick, activeFilterLabel }) => {
  const classes = styles()
  const [customDate, setCustomDate] = useState<{ from: any; to: any }>({
    from: null,
    to: null
  })

  useEffect(() => {
    if (customDate.from && customDate.to) {
      onClick({
        startTime: dayjs(
          new Date(customDate.from.year, customDate.from.month - 1, customDate.from.day)
        )
          .startOf('day')
          .unix(),
        endTime: dayjs(new Date(customDate.to.year, customDate.to.month - 1, customDate.to.day))
          .endOf('day')
          .unix(),
        label: DATE_FILTER_TYPE_VS_LABEL[DATE_FILTER_TYPE.CUSTOM_DATE]
      })
    }
  }, [customDate])

  useEffect(() => {
    if (activeFilterLabel !== DATE_FILTER_TYPE_VS_LABEL[DATE_FILTER_TYPE.CUSTOM_DATE]) {
      setCustomDate({ from: null, to: null })
    }
  }, [activeFilterLabel])

  const onCustomDateChange = (date: any) => {
    setCustomDate(date)
  }

  const renderCustomInput = ({ ref }: { ref: any }) => (
    <div className={classes.inputContainer}>
      <input
        readOnly
        ref={ref}
        placeholder="Select Date"
        value={
          customDate?.from && customDate?.to
            ? DATE_FILTER_TYPE_VS_LABEL[DATE_FILTER_TYPE.CUSTOM_DATE]
            : ''
        }
        className={cx(classes.datePicker, classes.filter, {
          [classes.customDateActive]:
            activeFilterLabel === DATE_FILTER_TYPE_VS_LABEL[DATE_FILTER_TYPE.CUSTOM_DATE]
        })}
      />
      {!customDate.from && !customDate.to && (
        <span className={classes.adornElement}>
          <CaretDownIcon fill={THEME.brandDarkerGrey} />
        </span>
      )}
    </div>
  )

  const handleFilterClick = (filterType: DATE_FILTER_TYPE) => () => {
    onClick({
      ...getDateFilterDetails(filterType),
      label: DATE_FILTER_TYPE_VS_LABEL[filterType]
    })
  }

  return (
    <div className={classes.root}>
      <DatePicker
        value={customDate}
        onChange={onCustomDateChange}
        shouldHighlightWeekends
        renderInput={renderCustomInput}
        maximumDate={getToday()}
        inputPlaceholder="Pick a date"
        calendarPopperPosition="bottom"
      />
      {Object.values(DATE_FILTER_TYPE)
        .filter((filterType) => filterType !== DATE_FILTER_TYPE.CUSTOM_DATE)
        .map((filterType: DATE_FILTER_TYPE) => {
          const label = DATE_FILTER_TYPE_VS_LABEL[filterType]
          return (
            <Chip
              key={filterType}
              clickable
              label={label}
              className={cx(classes.filter, {
                [classes.filterActive]: activeFilterLabel === label
              })}
              onClick={handleFilterClick(filterType)}
              active={activeFilterLabel === label}
            />
          )
        })}
    </div>
  )
}

export default DateFilter
